<template>
  <div class="topImgRect">
    <van-swipe :autoplay="3000" @change="onChange">
      <van-swipe-item v-for="(item, index) in images" :key="index">
        <van-image
          fit="cover"
          width="100vw"
          height="60vw"
          :src="item.img"
          @click="jumpUrl(item.url)"
        /></van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">
          <div v-for="(item,index) in images" :key="index" class="custom-indicator-item" :style="index===current?'background-color: rgba(255, 255, 255, 1);':'background-color: rgba(255, 255, 255, 0.7);'" />
        </div>
      </template>
    </van-swipe>
    <div class="topImgDown" />
    <div class="topImgDownRight" />
    <!-- <div class="topTitle"><span>酷潜全球船宿精选</span></div> -->
  </div>
</template>
<script>
import request from '@/utils/request'
import { Swipe, SwipeItem, Image } from 'vant'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Image.name]: Image,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  data() {
    return {
      images: ['/img/boat/homtTopBack1.webp', '/img/boat/homtTopBack2.webp', '/img/boat/homtTopBack3.webp'],
      current: 0

    }
  },

  created() {
    this.initTopRes()
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onChange(index) {
      this.current = index
    },
    initTopRes(){
      request({
        url: '/DiveBoat/getBoatHomeAdList?onlyTop=true',
        method: 'post',
      }).then(response => {
        if (!response.success) {
          return
        }
        this.images = response.data.top
      })
    },
    jumpUrl(url){
      console.log("jumpUrl",url)
      if(url){
        this.$router.push(url)
      }
    },
  }
}
</script>

  <style>
.topImgRect .custom-indicator {
    position: absolute;
    left:2em;
    bottom:2.8em;
    width:100vw;
    height:0.2em;
    display:flex;
  }
  .topImgRect .custom-indicator-item{
    width:6.5vw;
    height:2px;
    margin-right:1.5vw;
  }
  .topImgRect{
      width:100vw;
      height:60vw;
      position:relative;
  }
  .topImgRect  .topImgDown{
      position:absolute;
      z-index:1;
      bottom:0;
      left:0;
      right:0;
      height:2em;
      background-color:#fff;
      border-radius: 2em 0 0 0;
  }
  .topImgRect  .topImgDownRight{
      position:absolute;
      z-index:1;
      bottom:1.3em;
      width:2.6em;
      right:-0.7em;
      height:2.6em;
      background-color:#fff;
      -webkit-mask-image: radial-gradient(circle at 0 0%, transparent 50%, black 50%); /* WebKit 浏览器 */
      mask-image: radial-gradient(circle at 0 0%, transparent 50%, black 50%);
  }
  .topImgRect  .topTitle{
    color:#fff;
    position:absolute;
    z-index:2;
    left:2em;
    top:30vw;
  }
  .topImgRect  .topTitle span{
    color:#fff;
    font-size:1.2em;
    font-weight:700;
    z-index:2;
    top:30vw;
     /* font-style: oblique 1deg;*/
    letter-spacing: 1px;
  }
  </style>

